export const META_TYPE = 'plugVue';
export const META_VER = 'v1';

export const CMD_PLUGVUE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
